var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocSplitting = function SvgDocSplitting(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 19,
    "data-width-28": 22,
    "data-width-72": 55,
    viewBox: "0 0 12.4 13",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.167 4.833c0-1 .036-1.292-.334-1.666L8.198 1.095A2 2 0 0 0 6.775.5H2.5C.833.5.5.833.5 2.5v8c0 1.667.333 2 2 2h2M2.833 3.167h4.334m-4.334 2H5.5m-1 4h.333m1.334 0H6.5m-3.667 0h.334m-.334-2h1M9.967 10.3 6.5 6.833m3.467 1.2L6.5 11.5m5.334-.667a1 1 0 1 0-2.001 0 1 1 0 0 0 2 0m0-3.333a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocSplitting);
export default ForwardRef;